import { useState, useEffect } from 'react';
import { Brand } from 'models/BO/Brand';
import { getMyRolesDO } from 'utils/rolesUtils';

export const useBrandManagement = (currentUser: any, brands: Brand[], dispatch: any) => {
  const [allowedBrands, setAllowedBrands] = useState<Partial<Brand>[]>([]);
  const [roles, setRoles] = useState<any[]>([]);

  const prepareAllowedBrands = (user: any) => {
    const filteredBrands = brands.filter((brand) => user?.brands.includes(brand?.id));
    setAllowedBrands(filteredBrands);
    const localStorageBrand = JSON.parse(localStorage.getItem("currentBrand") || "null") || brands[0];
    return localStorageBrand;
  };

  useEffect(() => {
    if (currentUser !== null) {
      prepareAllowedBrands(currentUser);
      getMyRolesDO().then((res) => {
        setRoles(res);
      });
    } else {
      prepareAllowedBrands(JSON.parse(localStorage.getItem("BOCurrentUser") || "null"));
    }
  }, [currentUser, brands]);

  return {
    allowedBrands,
    roles,
    prepareAllowedBrands
  };
}; 